import React, { Component } from "react";
import { getChatList, getChannel } from "../../actions/chatActions";
import { connect } from "react-redux";
import PubNubReact from "pubnub-react";
import { Redirect } from 'react-router-dom';
import Navigation from "../Navigation/Navigation";
import Footer from "../General/Footer";
import ChatList from "./chatList";
import MessageList from "./messageList";
import Compose from "./compose";

class Chat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            conversations: [],
            channels: [],
            selectedChannel: {}
        }
        this.pubnub = new PubNubReact({
            publish_key: 'pub-c-7e154e57-b854-4dc4-ad61-263d96a4640c',
            subscribe_key: 'sub-c-7c617876-80b8-11e9-8b01-daac65ed15f3',
            ssl: window.location.protocol.toLowerCase() === "https:"
        });
        this.pubnub.init(this);
        this.changeConversation = this.changeConversation.bind(this);
        this.scrollDone = this.scrollDone.bind(this);
        this.publish = this.publish.bind(this);
        this.newSubscribe = this.newSubscribe.bind(this);
    }

    componentDidMount() {
        let select = undefined;
        if (this.props.location && this.props.location.state) {
            select = this.props.location.state.select;
        }
        if (this.props.user && this.props.user.userProfile) {
            getChatList({ userId: this.props.user.userProfile.sub }, this.props.user.token).then((res) => {
                this.setConversations(res.data, select).then(() => {
                    this.pubnub.subscribe({
                        channels: this.state.channels,
                        withPresence: true
                    });
                    this.state.channels.forEach((channel) => {
                        this.pubnub.history({
                            channel,
                            count: 100
                        }).then((result) => {
                            let conversations = this.state.conversations;
                            for (let i = 0; i < conversations.length; ++i) {
                                if (conversations[i].channel === channel) {
                                    let messages = [];
                                    result.messages.forEach((message) => {
                                        messages.push(message.entry);
                                    })
                                    conversations[i].history = conversations[i].history.concat(messages);
                                    if (conversations[i].history.length > 0) {
                                        conversations[i].lastText = conversations[i].history[conversations[i].history.length - 1].text;
                                    }
                                    else {
                                        conversations[i].lastText = "";
                                    }
                                    this.setState({
                                        conversations
                                    })
                                    if (this.state.selectedChannel.channel === conversations[i].channel) {
                                        this.setState({
                                            selectedChannel: conversations[i],
                                            scroll: true
                                        })
                                    }
                                    i = conversations.length;
                                }
                            }
                        })
                        this.pubnub.getMessage(channel, (msg) => {
                            let conversations = this.state.conversations;
                            for (let i = 0; i < conversations.length; ++i) {
                                if (conversations[i].channel === channel) {
                                    conversations[i].history = conversations[i].history.concat(msg.message);
                                    if (conversations[i].history.length > 0) {
                                        conversations[i].lastText = conversations[i].history[conversations[i].history.length - 1].text;
                                    }
                                    else {
                                        conversations[i].lastText = "";
                                    }
                                    this.setState({
                                        conversations
                                    })
                                    if (this.state.selectedChannel.channel === conversations[i].channel) {
                                        let updateChannel = this.state.selectedChannel;
                                        updateChannel.history = conversations[i].history;
                                        this.setState({
                                            selectedChannel: updateChannel,
                                            scroll: true
                                        })
                                    }
                                }
                            }
                        })
                    })
                })
            }).catch((err) => {
                console.log("err: ", err)
            })
        }
    }

    setConversations = (chatList, select) => {
        return new Promise((res, rej) => {
            let channels = [];
            let asSelected = false;
            let selectedChannel = {};
            if (chatList.length > 0) {
                let foundSelect = false;
                if (!select) {
                    foundSelect = true;
                }
                let conversations = chatList.map((chat) => {
                    let conversation = {
                        ...chat,
                        name: `${chat.otherUserName} ${chat.otherUserLastName}`,
                        lastText: "",
                        history: []
                    }
                    channels.push(conversation.channel);
                    if (!asSelected || (select && select.channel === conversation.channel)) {
                        asSelected = true;
                        if (select && select.channel === conversation.channel) {
                            foundSelect = true;
                        }
                        selectedChannel = conversation;
                    }
                    return conversation
                });
                if (!foundSelect) {
                    let newConversation = {
                        channel: select.channel,
                        history: [],
                        lastText: "",
                        name: `${select.otherUserName} ${select.otherUserLastName}`,
                        otherUserLastName: select.otherUserLastName,
                        otherUserName: select.otherUserName,
                        otherUserImage: select.otherUserImage
                    }
                    conversations.unshift(newConversation);
                    channels.push(select.channel);
                    selectedChannel = newConversation;
                }
                this.setState({
                    selectedChannel,
                    channels,
                    conversations
                }, () => {
                    res(conversations);
                })
            }
            else {
                if (select) {
                    let newConversation = {
                        channel: select.channel,
                        history: [],
                        lastText: "",
                        name: `${select.otherUserName} ${select.otherUserLastName}`,
                        otherUserLastName: select.otherUserLastName,
                        otherUserName: select.otherUserName,
                        otherUserImage: select.otherUserImage
                    }
                    let conversations = [newConversation];
                    channels.push(select.channel);
                    selectedChannel = newConversation;
                    this.setState({
                        selectedChannel,
                        channels,
                        conversations
                    }, () => {
                        res(conversations);
                    })
                }
                else {
                    res([]);
                }
            }
        })
    }

    changeConversation(newConversation) {
        if (newConversation.channel !== this.state.selectedChannel.channel) {
            this.setState({
                selectedChannel: newConversation,
                scroll: true
            })
        }
    }

    scrollDone() {
        this.setState({
            scroll: false
        });
    }

    sendMessage = (message) => {
        let select = undefined;
        if (this.props.location && this.props.location.state) {
            select = this.props.location.state.select;
        }
        if (select && this.state.selectedChannel.history.length === 0) {
            getChannel({
                create: true,
                userId: this.props.user.userProfile.sub,
                otherUserId: select.otherUserId
            }, this.props.user.token).then((res) => {
                if (this.state.selectedChannel.channel === res.data.channel) {
                    this.publish(message);
                }
                else {
                    this.replaceConversation(res.data.channel, this.state.selectedChannel.channel, message);
                }
            }).catch((err) => {
                console.log(err);
            })
        }
        else {
            this.publish(message);
        }
    }

    publish(message) {
        message.sender = this.props.user.userProfile.sub;
        this.pubnub.publish({
            channel: this.state.selectedChannel.channel,
            message,
            storeInHistory: true
        }, (status, response) => {
            if (status.error) {
                console.log(status);
            }
        })
    }

    replaceConversation(newConvo, oldConvo, message) {
        let conversations = this.state.conversations;
        let newSelect = {};
        for (let i = 0; i < conversations.length; ++i) {
            if (conversations[i].channel === oldConvo) {
                conversations[i].channel = newConvo;
                newSelect = conversations[i];
                i = conversations.length;
            }
        }
        this.setState({
            conversations,
            channels: this.state.channels.concat([newConvo]),
            selectedChannel: newSelect
        }, () => {
            this.newSubscribe(message, newConvo);
        })
    }

    newSubscribe(message, channel) {
        this.pubnub.subscribe({
            channel: channel,
            withPresence: true
        });
        this.pubnub.history({
            channel: channel,
            count: 100
        }).then((result) => {
            let conversations = this.state.conversations;
            for (let i = 0; i < conversations.length; ++i) {
                if (conversations[i].channel === channel) {
                    let messages = [];
                    result.messages.forEach((message) => {
                        messages.push(message.entry);
                    })
                    conversations[i].history = conversations[i].history.concat(messages);
                    if (conversations[i].history.length > 0) {
                        conversations[i].lastText = conversations[i].history[conversations[i].history.length - 1].text;
                    }
                    else {
                        conversations[i].lastText = "";
                    }
                    this.setState({
                        conversations
                    })
                    if (this.state.selectedChannel.channel === conversations[i].channel) {
                        this.setState({
                            selectedChannel: conversations[i],
                            scroll: true
                        })
                    }
                    this.publish(message);
                    i = conversations.length;
                }
            }
        })
        this.pubnub.getMessage(channel, (msg) => {
            let conversations = this.state.conversations;
            for (let i = 0; i < conversations.length; ++i) {
                if (conversations[i].channel === channel) {
                    conversations[i].history = conversations[i].history.concat(msg.message);
                    if (conversations[i].history.length > 0) {
                        conversations[i].lastText = conversations[i].history[conversations[i].history.length - 1].text;
                    }
                    else {
                        conversations[i].lastText = "";
                    }
                    this.setState({
                        conversations
                    })
                    if (this.state.selectedChannel.channel === conversations[i].channel) {
                        let updateChannel = this.state.selectedChannel;
                        updateChannel.history = conversations[i].history;
                        this.setState({
                            selectedChannel: updateChannel,
                            scroll: true
                        })
                    }
                }
            }
        })
    }

    render() {
        const { props, sendMessage, state } = this;
        if (!props.user.userProfile) {
            return <Redirect to="/" />
        }
        return (
            <div className="chatpage">
                <Navigation auth={this.props.auth} />
                <div className="page__hero">
                    <h4 className="page-title page__hero__title">Chat</h4>{console.log(this.state.conversations)}
                </div>
                {this.state.conversations.length === 0 ?
                    <div className="chat__nomessages__container">
                        <h4 className="chat__nomessages rides-title">
                            Vous n'avez aucun message 🌴
                        </h4>
                    </div>

                    :
                    <div className="messenger">
                        <div className="scrollable sidebar">
                            <ChatList chatList={state.conversations} changeConversation={this.changeConversation} selected={this.state.selectedChannel} />
                        </div>
                        <div className="scrollable content">
                            <MessageList conversation={state.selectedChannel} userId={this.props.user.userProfile.sub} scroll={this.state.scroll} scrollDone={this.scrollDone} />
                        </div>
                        <div className="footer">
                            <Compose sendMessage={sendMessage} />
                        </div>
                    </div>
                }
                <Footer />
            </div>
        )
    }
}

export default connect((state) => {
    return {
        user: state.reducerUser
    }
})(Chat);